module.exports = __webpack_public_path__ + "static/media/Events-04.c04f0428.webp";